<template>
  <div class="card">
    <div class="card-body">
      <form
        @submit.prevent="
          user.two_fa_is_active ? submitWithdrawal() : toggleModalOtp()
        "
      >
        <div class="mt-4">
          <div v-if="networkLabel" class="row mt-1 mb-2">
            <label class="col-md-4 text-md-right">Network :</label>
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                :value="networkLabel"
                readonly
              />
            </div>
          </div>

          <div v-if="travel_rules_element" class="mb-4">
            <div class="row mt-1">
              <div class="col-md-4 text-md-right">&nbsp;</div>
              <div class="col-md-8">
                <h4 class="text-light">Travel Rules</h4>
              </div>
            </div>
            <div class="row mt-1">
              <label class="col-md-4 text-md-right">Nama Penerima :</label>
              <div class="col-md-8">
                <input type="text" v-model="wd.to_name" class="form-control" />
              </div>
            </div>
            <div class="row mt-1">
              <label class="col-md-4 text-md-right">Alamat Penerima :</label>
              <div class="col-md-8">
                <input
                  type="text"
                  v-model="wd.to_home_address"
                  class="form-control"
                />
              </div>
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-md-right">Wallet Address :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.withdraw_to"
                class="form-control"
              />
            </div>
          </div>

          <div class="row mt-1" v-if="currency == 'XRP'">
            <label class="col-md-4 text-md-right">Destination Tag :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.destinationtag"
                class="form-control"
              />
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-md-right">Jumlah :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.amount"
                class="form-control"
                v-clear-zero
                placeholder="0"
                @keyup="calcAfterFee"
                @keydown="calcAfterFee"
              />
              <small class="text-muted d-block mt-1">
                Minimal withdraw: {{ formattedMinWithdraw }} {{ currency }}
              </small>
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-md-right">Biaya :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.fee"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="row mt-1">
            <label class="col-md-4 text-md-right">Terima Bersih :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="after_fee"
                class="form-control"
                readonly
              />
            </div>
          </div>

          <div class="row mt-1" v-if="user.two_fa_is_active == false">
            <label class="col-md-4 text-md-right">OTP :</label>
            <div class="col-md-8">
              <div class="input-group">
                <input type="text" v-model="wd.otp" class="form-control" />
                <div class="input-group-append">
                  <BtnRequestOtp />
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-1" v-if="user.two_fa_is_active == true">
            <label class="col-md-4 text-md-right">Google Secret :</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="wd.google_secret"
                class="form-control"
              />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-4">&nbsp;</div>
            <div class="col-md-8">
              <button
                type="submit"
                class="btn btn-light"
                :disabled="!canSubmit"
              >
                Withdraw
              </button>
              <small
                v-if="isBelowMinWithdraw"
                class="text-warning d-block mt-2"
              >
                Jumlah withdraw minimal {{ formattedMinWithdraw }}
                {{ currency }}
              </small>
              <small
                v-else-if="isInsufficientBalance"
                class="text-warning d-block mt-2"
              >
                Jumlah melebihi saldo tersedia
              </small>
              <small v-else-if="!hasAuthCode" class="text-warning d-block mt-2">
                {{
                  user.two_fa_is_active
                    ? "Google Secret wajib diisi"
                    : "OTP wajib diisi"
                }}
              </small>
            </div>
          </div>
        </div>
      </form>
      <ModalAmlHold
        :show="showAmlHold"
        :title="amlHoldTitle"
        :body="amlHoldBody"
        @close="onAmlHoldClose"
      />
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { useToast } from "vue-toastification";
import thestore from "@/applibs/thestore.js";
import { getWalletGroupLabel } from "@/applibs/walletGroupConfig.js";
import BtnRequestOtp from "@/components/global/BtnRequestOtp.vue";
import ModalAmlHold from "@/components/modals/ModalAmlHold.vue";
import { isAmlHold, amlHoldCopy } from "@/applibs/amlHold.js";

const toast = useToast();

export default {
  components: {
    BtnRequestOtp,
    ModalAmlHold,
  },
  props: {
    currency: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    ccurrencyObj: {
      type: Object,
      required: true,
    },
    network: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      after_fee: 0,
      availableBalance: 0,
      showAmlHold: false,
      amlHoldTitle: "",
      amlHoldBody: "",
      travel_rules_element: false,
      wd: {
        to_name: "",
        to_home_address: "",
        amount: 0,
        otp: "",
        google_secret: "",
        withdraw_to: "",
        destinationtag: "",
        fee: this.ccurrencyObj.ccurrency_withdraw_fee || 0,
      },
    };
  },

  computed: {
    networkLabel() {
      return this.network ? getWalletGroupLabel(this.network) : "";
    },
    requiresNetwork() {
      const groups = Array.isArray(this.ccurrencyObj.ccurrency_wallet_group)
        ? this.ccurrencyObj.ccurrency_wallet_group
        : this.ccurrencyObj.ccurrency_wallet_group
        ? [this.ccurrencyObj.ccurrency_wallet_group]
        : [];
      return groups.length > 1;
    },
    withdrawAmount() {
      return parseFloat(this.wd.amount) || 0;
    },
    minWithdraw() {
      return parseFloat(this.ccurrencyObj.ccurrency_wd_min_in_idr) || 0;
    },
    formattedMinWithdraw() {
      const decimals = parseInt(this.ccurrencyObj.decimal_display, 10);
      const places = Number.isFinite(decimals) ? decimals : 8;
      return this.minWithdraw.toFixed(places).replace(/\.?0+$/, "") || "0";
    },
    isBelowMinWithdraw() {
      return this.minWithdraw > 0 && this.withdrawAmount < this.minWithdraw;
    },
    isInsufficientBalance() {
      return this.withdrawAmount > (parseFloat(this.availableBalance) || 0);
    },
    hasAuthCode() {
      if (this.user.two_fa_is_active) {
        return String(this.wd.google_secret || "").trim().length > 0;
      }
      return String(this.wd.otp || "").trim().length > 0;
    },
    canSubmit() {
      if (this.requiresNetwork && !this.network) {
        return false;
      }
      if (!this.wd.withdraw_to || this.withdrawAmount <= 0) {
        return false;
      }
      if (this.isBelowMinWithdraw || this.isInsufficientBalance) {
        return false;
      }
      return this.hasAuthCode;
    },
  },

  watch: {
    ccurrencyObj: {
      immediate: true,
      handler(val) {
        if (val && val.ccurrency_withdraw_fee != null) {
          this.wd.fee = val.ccurrency_withdraw_fee;
        }
      },
    },
  },

  sockets: {
    ubal: function (data) {
      var self = this;
      var obj;
      try {
        obj = typeof data === "string" ? JSON.parse(data) : data;
      } catch (e) {
        return;
      }
      if (!Array.isArray(obj)) {
        obj = [obj];
      }
      obj.forEach(function (el) {
        if (!el || parseInt(self.usid, 10) !== parseInt(el.u, 10)) {
          return;
        }
        if (el[self.currency] != null) {
          self.availableBalance = el[self.currency];
        }
      });
    },
  },

  async mounted() {
    await this.getAvailableBalance();
  },

  methods: {
    async getAvailableBalance() {
      var filter_rules = [
        { field: "ccurrency_symbol", op: "equal", value: this.currency },
      ];
      var res = await thestore.getBalances(
        this.token,
        1,
        1,
        "id",
        "asc",
        filter_rules
      );
      if (res.datas && res.datas[0]) {
        this.availableBalance = res.datas[0].saldo_value;
      }
    },

    calcAfterFee() {
      this.after_fee =
        parseFloat(this.wd.amount || 0) - parseFloat(this.wd.fee || 0);
      this.travel_rules_element =
        parseFloat(this.wd.amount || 0) >=
        (this.ccurrencyObj.travel_rules_limit || 0);
    },

    toggleModalOtp() {
      this.submitWithdrawal();
    },

    onAmlHoldClose() {
      this.showAmlHold = false;
      this.$router.go();
    },

    async submitWithdrawal() {
      if (this.requiresNetwork && !this.network) {
        toast.warning("Pilih network terlebih dahulu");
        return;
      }

      if (this.isInsufficientBalance) {
        toast.warning("Jumlah melebihi saldo tersedia");
        return;
      }

      if (this.isBelowMinWithdraw) {
        toast.warning(
          `Jumlah withdraw minimal ${this.formattedMinWithdraw} ${this.currency}`
        );
        return;
      }

      if (!this.hasAuthCode) {
        toast.warning(
          this.user.two_fa_is_active
            ? "Google Secret wajib diisi"
            : "OTP wajib diisi"
        );
        return;
      }

      if (
        parseFloat(this.wd.amount) >=
        (this.ccurrencyObj.travel_rules_limit || 0)
      ) {
        if (this.wd.to_name == "" || this.wd.to_home_address == "") {
          alert("Anda wajib mengisi nama dan alamat penerima");
          return;
        }
      }

      var res = await thestore.postWalletsCipherbcWithdraw(
        this.token,
        this.currency,
        this.wd.withdraw_to,
        this.wd.to_name,
        "",
        this.wd.to_home_address,
        this.wd.destinationtag,
        this.wd.amount,
        this.wd.otp,
        this.wd.google_secret,
        this.network
      );

      if (res.success == true) {
        if (isAmlHold(res)) {
          const copy = amlHoldCopy(res);
          this.amlHoldTitle = copy.title;
          this.amlHoldBody = copy.body;
          this.showAmlHold = true;
        } else {
          alert("Success");
          this.$router.go();
        }
      } else {
        alert(res.msg || res.message);
      }
    },
  },
};
</script>
